@if (dataMode != 'summary') {
  <button [style.z-index]="2" type="button" (click)="showTimelineChart()" tooltip="Back to Summary" class="btn btn-outline-secondary btn-sm float-left position-relative m-2">
    <i class="fas fa-arrow-left"></i>
  </button>
}

<div id="chart_cleanid_timeline"></div>
